import rootReducer from './reducer'
import rootSaga from './saga'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'

export default function() {
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(sagaMiddleware)
  )

  sagaMiddleware.run(rootSaga)

  return store
}



// WEBPACK FOOTER //
// ./src/redux/store.js